import { SxProps, Theme } from '@mui/material/styles'

export const styles = {
  userContainer: {
    display: 'flex',
    flexDirection: 'column',
  } as SxProps<Theme>,
  multiUserContainer: {
    border: '1px dotted black',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    borderRadius: '2.5px',
  } as SxProps<Theme>,
  userIcon: {
    display: 'flex',
    alignItems: 'center',
  } as SxProps<Theme>,
  validationContainer: {
    position: 'relative',
    display: 'flex',
  } as SxProps<Theme>,
  validationIcon: {
    position: 'absolute',
    width: '30px !important',
    height: '30px !important',
    right: '-50px',
    top: '27px',
  } as SxProps<Theme>,
  validationText: {
    position: 'absolute',
    height: '30px !important',
    top: '70px',
    right: '0',
    textAlign: 'right',
  } as SxProps<Theme>,
}
